// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K5XbbIFrQ8LEJ2BjycKc {
  padding: 0;
}

.SuQqQRpO2bYP6UTWJgEQ {
  background: #ececec;
  border: 1px solid #c7c7c7;
  padding: 8px 12px;
}

.ymanRAHgO4uDT5lFYv8C {
  font-size: 14px;
  font-weight: 800;
  margin: 5px 0 10px;
}

.nrTOdbwjBTrhVFChuIl9 {
  margin-bottom: 10px;
}

.Qf6flPptTmsIermXrXyq {
  font-weight: 600px;
}`, "",{"version":3,"sources":["webpack://./src/pages/waitlist-update/update-form/components/verify-address.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".container {\n  padding: 0;\n}\n\n.disclaimer {\n  background: #ececec;\n  border: 1px solid #c7c7c7;\n  padding: 8px 12px;\n}\n\n.addressHeading {\n  font-size: 14px;\n  font-weight: 800;\n  margin: 5px 0 10px;\n}\n\n.address {\n  margin-bottom: 10px;\n}\n\n.suggestedColumn {\n  font-weight: 600px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `K5XbbIFrQ8LEJ2BjycKc`,
	"disclaimer": `SuQqQRpO2bYP6UTWJgEQ`,
	"addressHeading": `ymanRAHgO4uDT5lFYv8C`,
	"address": `nrTOdbwjBTrhVFChuIl9`,
	"suggestedColumn": `Qf6flPptTmsIermXrXyq`
};
export default ___CSS_LOADER_EXPORT___;
